import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./invoice/invoice-page.module').then(m => m.InvoicePageModule),
    canActivate: [featureToggleGuard],
    data: { feature: 'invoice' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InvoiceRoutingModule {}
